// extracted by mini-css-extract-plugin
export var langSwitcher = "LangSwitcher-module--langSwitcher--XRkBb";
export var langOpts = "LangSwitcher-module--langOpts--1H9ZD";
export var opt = "LangSwitcher-module--opt--qNWHC";